import { render, staticRenderFns } from "./InactiveStudentCard.vue?vue&type=template&id=557c2bd8&scoped=true&"
import script from "./InactiveStudentCard.vue?vue&type=script&lang=js&"
export * from "./InactiveStudentCard.vue?vue&type=script&lang=js&"
import style0 from "./InactiveStudentCard.vue?vue&type=style&index=0&id=557c2bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c2bd8",
  null
  
)

export default component.exports